import { render } from "./Teacher.vue?vue&type=template&id=50f02172"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"
script.render = render

export default script